













import OnlineBookingForm from '@bookings/components/online-booking/online-booking-form.vue';
import ModulesHelper from '@core/services/modules.helper';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import PageTitle from '@shared/layouts/components/page-title/page-title.vue';

@Component({
  name: 'bpc-profile-new-booking',
  components: {
    'bpc-online-booking-form': OnlineBookingForm,
    'bpc-page-title': PageTitle,
  },
})
export default class ProfileOnlineBookingPage extends Vue {
  /* Lifecycle hooks */

  get usingOnlineBookingV2() {
    return this.$modulesService.hasModuleActivated(ModulesHelper.ONLINE_BOOKING_V2_MODULE_NAME);
  }
  created() {
    if (!this.usingOnlineBookingV2) {
      this.$router.push({ name: 'profile-new-booking' });
    }
  }
  // mounted () { }
  // updated () { }
  // destroyed () { }
}
